import React from 'react'
import { Text } from 'native-base'
import type { StyleProp, TextStyle } from 'react-native'

const Italic: React.FC<{
  style?: StyleProp<TextStyle>;
  testID?: string;
}> = ({ children, style, testID }) => {
  return (
    <Text
      testID={testID}
      fontSize="md"
      fontWeight={300}
      fontFamily="Lato"
      color="dark"
      style={style}
      fontStyle="italic"
    >
      {children}
    </Text>
  )
}

export default Italic
